import React, { Component } from 'react';
import style from './index.module.css';

class Chapter4 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      status,
      latestChargeName,
      latestChargeDay,
      latestChargeHour
    } = this.props.data;
    // if (status === 0) return;

    return (
      <div
        className={style.nightPage}
        style={{
          height: document.documentElement.clientHeight
        }}
      >
        <div
          // className={style.itemBox}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            paddingRight: 0,
            paddingLeft: 0,
            paddingTop: 0,
            height: document.documentElement.clientHeight,
            width: document.documentElement.clientWidth
          }}
        >
          <div className={style.chapter4Icon} />
          {status === 1 && (
            <div className={style.itemBox}>
              {/* <div className={style.nightPage} /> */}
              {/* <div className={style.xpWhiteIconBox} /> */}
              <p className={style.ordinaryWhiteText}>
                <span className={style.whiteBigText}>
                  {latestChargeDay}
                  <br />
                  这一天很特别
                </span>
                <br />
                <span className={style.blueNormalText}>
                  深夜{latestChargeHour}
                </span>
                <br />
                <span className={style.latestChargeNameText}>
                  您仍在{latestChargeName}充电
                </span>
                <br />
                <span style={{ opacity: 0.6 }}>
                  生活纵然繁忙，也要记得给自己加电哦
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Chapter4;
